/**
 * TODO: Add working hours (workdayStartHour, workdayStopHour) to the hospital model in the database
 * and fetch this data from the API. These values are currently frontend-only fallbacks.
 * Also worth to consider using time instead of hours (HH:mm) for the start and stop hours.
 */

/** Default workday start hour when not provided by backend. */
export const DEFAULT_WORKDAY_START_HOUR = 7;

/** Default workday stop hour when not provided by backend. */
export const DEFAULT_WORKDAY_STOP_HOUR = 22;
